export enum FeedbackRating {
    ThumbsDown = 0,
    ThumbsUp = 1,
}
